module.exports = __webpack_public_path__ + "img/9788991508989.2fd04cf5.jpg";